export default __webpack_public_path__ + "assets/7427e4.jpg";